var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_236_25727"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_236_25727)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 6.5,
    height: 12.5,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 24.75,
    width: 6.5,
    height: 6.5,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 8.75,
    width: 12.5,
    height: 5.5,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 17.75,
    width: 12.5,
    height: 13.5,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/area-icon.9f8eae7c925d0adb1ac14c146a317038.svg";
export { ForwardRef as ReactComponent };